// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__3nObR"};